export interface TabItem {
	id: string;
	title: string;
	tableName: string;
}
